import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import styles from '../styles/WeekControls.module.css';

function WeekControls({
  displayedWeek,
  visibleWeeks,
  currentWeek,
  changeWeek,
  setDisplayedWeek,
  fetchWatchedPicks,
  handleCurrentWeek,
  getWeekLabel
}) {
  const [isVisible, setIsVisible] = useState(true);
  const lastScrollY = useRef(0);
  const controlsRef = useRef(null);

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;
      if (currentScrollY < lastScrollY.current) {
        // Scrolling up
        setIsVisible(true);
      } else {
        // Scrolling down
        setIsVisible(false);
      }
      lastScrollY.current = currentScrollY;
    };

    window.addEventListener('scroll', handleScroll, { passive: true });

    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div
      className={`${styles.weekControlsContainer} ${isVisible ? styles.visible : styles.hidden}`}
      ref={controlsRef}
    >
      <button
        className={`${styles.weekButton} ${styles.prevWeek}`}
        onClick={() => changeWeek('prev')}
        disabled={displayedWeek === visibleWeeks[0]?.week}
      >
        &lt; Previous Week
      </button>
      <select
        className={styles.weekSelect}
        value={displayedWeek || ''}
        onChange={(e) => {
          const newWeek = Number(e.target.value);
          setDisplayedWeek(newWeek);
          fetchWatchedPicks(newWeek);
        }}
      >
        <option value="" disabled>Select a week</option>
        {visibleWeeks.map((week) => (
          <option key={week.week} value={week.week}>
            {getWeekLabel(week)}
          </option>
        ))}
      </select>
      <button
        className={`${styles.weekButton} ${styles.currentWeek}`}
        onClick={handleCurrentWeek}
        disabled={displayedWeek === currentWeek || currentWeek === null}
      >
        Current Week
      </button>
      <button
        className={`${styles.weekButton} ${styles.nextWeek}`}
        onClick={() => changeWeek('next')}
        disabled={displayedWeek === visibleWeeks[visibleWeeks.length - 1]?.week}
      >
        Next Week &gt;
      </button>
    </div>
  );
}

WeekControls.propTypes = {
  displayedWeek: PropTypes.number,
  visibleWeeks: PropTypes.arrayOf(PropTypes.shape({
    week: PropTypes.number.isRequired,
  })).isRequired,
  currentWeek: PropTypes.number,
  changeWeek: PropTypes.func.isRequired,
  setDisplayedWeek: PropTypes.func.isRequired,
  fetchWatchedPicks: PropTypes.func.isRequired,
  handleCurrentWeek: PropTypes.func.isRequired,
  getWeekLabel: PropTypes.func.isRequired,
};

export default WeekControls;
